<template>
  <div>
    <div class="group-input col-12 column q-mt-sm">
      <div class="row">
        <label>O imóvel se encontra em trecho de rua não cabeada?</label>
      </div>
      <div class="flex row justify-around">
        <q-radio
          keep-color
          v-model="itemOsContract.rua_nao_cabeada"
          size="lg"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          keep-color
          size="lg"
          v-model="itemOsContract.rua_nao_cabeada"
          :val="0"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <MduNapForm :itemOsContract="itemOsContract" />
  </div>
</template>

<script>
  import MduNapForm from "@/components/SpecialCodes/Forms/MduNapForm.vue";
import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import { inject, onBeforeMount } from "vue";

  export default {
    name: "BuildingWithouthBackboneForm",
    components: {
      MduNapForm,
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
    },

    setup(props, { emit }) {
      let formFields = {
        rua_nao_cabeada: "",
        telefone_sindico_zelador: "",
      };
      const addFieldsToRequestData = inject("addFieldsToRequestData");

      onBeforeMount(() => {
        addFieldsToRequestData(formFields);
      });

      return {};
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
